import { isAuth } from "actions";
import axios from "axios";
import { MainLayout } from "components";
import { API_URL_department } from "constants/api";
import { menuAdmin, menuAgents, menuNav } from "constants/menu";
import {
  Portal,
  CreateCanned,
  MyTicket,
  CreateTicket,
  QuestionAnswer,
  Show,
  Login,
  LoginPage,
  PrivateRoute,
  IsLogged,
  Beranda,
  CreateTicketNonAuth,
  TicketDetailPortal,
  LoginByToken,
  ResetPassword,
  TicketDetail,
} from "pages";
import ForgotPassword from "pages/Portal/ForgotPassword";
import { Fragment, useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "react-photo-view/dist/react-photo-view.css";
import { AuthContext } from "context/AuthContext";

const App = () => {
  const IS_AUTH = isAuth() ?? false;
  return (
    <BrowserRouter>
      <Routes>
        {/* Portal */}
        <Route path="/" element={<Beranda />} />

        {/* Portal Login*/}
        <Route
          path="/auth-apjii/login"
          element={
            <IsLogged>
              <Login />
            </IsLogged>
          }
        />
        {/* Portal/tiketsaya */}
        {/* {IS_AUTH ? (
          <Route path="/buattiket" element={<CreateTicket />} />
        ) : (
          <Route path="/buattiket" element={<CreateTicketNonAuth />} />
        )} */}
        <Route path="/buattiket" element={<CreateTicket />} />

        {/* Portal/pertanyaan */}
        <Route path="/pertanyaan" element={<QuestionAnswer />} />
        {/* Portal/pertanyaan/pencarian */}
        <Route path="/pertanyaan/pencarian" element={<QuestionAnswer />} />
        {/* Portal/pertanyaan/:slug */}
        <Route path="/pertanyaan/:slug" element={<Show />} />
        {/* Forgot Password */}
        <Route path="/forgot-password" element={<ForgotPassword />} />
        {/* Reset Password */}
        <Route path="/reset-password/:token/" element={<ResetPassword />} />

        {/* Private Route authourization */}
        <Route element={<PrivateRoute />}>
          {/* Portal/buattiket */}
          <Route path="/tiketsaya" element={<MyTicket />} />
          {/* Portal/ */}
          <Route
            path="/tiketsaya/ticketdetail"
            element={<TicketDetailPortal />}
          />
          {/* Menu Dashboard */}
          <Route element={<MainLayout />}>
            <Route
              path="/tickets/ticketdetail/:id_ticket"
              element={<TicketDetail />}
            />
            {/* Admin */}
            {menuAdmin.map((level1, level1Idx) => {
              // Level 1
              if (level1.element && level1.sub.length === 0) {
                return (
                  <Route
                    key={level1Idx}
                    path={level1.path}
                    element={level1.element}
                  />
                );
              }

              if (!level1.element && level1.sub.length > 0) {
                return (
                  <Fragment key={level1Idx}>
                    {level1.sub.map((level2, level2Idx) => {
                      // Level 2
                      if (level2.element && level2.sub.length === 0) {
                        return (
                          <Route key={level2Idx} path={level1.path}>
                            <Route
                              path={level2.path}
                              element={level2.element}
                            />
                          </Route>
                        );
                      }

                      // Level 3
                      if (!level2.element && level2.sub.length > 0) {
                        return (
                          <Route key={level2Idx} path={level1.path}>
                            <Route path={level2.path}>
                              {level2.sub.map((level3, level3Idx) => (
                                <Route
                                  key={level3Idx}
                                  path={level3.path}
                                  element={level3.element}
                                />
                              ))}
                            </Route>
                          </Route>
                        );
                      }

                      return null;
                    })}
                  </Fragment>
                );
              }

              return null;
            })}
            {/* Agents */}
            {menuAgents.map((level1, level1Idx) => {
              // Level 1
              if (level1.element && level1.sub.length === 0) {
                return (
                  <Route
                    key={level1Idx}
                    path={level1.path}
                    element={level1.element}
                  />
                );
              }

              if (!level1.element && level1.sub.length > 0) {
                return (
                  <Fragment key={level1Idx}>
                    {level1.sub.map((level2, level2Idx) => {
                      // Level 2
                      if (level2.element && level2.sub.length === 0) {
                        return (
                          <Route key={level2Idx} path={level1.path}>
                            <Route
                              path={level2.path}
                              element={level2.element}
                            />
                          </Route>
                        );
                      }

                      // Level 3
                      if (!level2.element && level2.sub.length > 0) {
                        return (
                          <Route key={level2Idx} path={level1.path}>
                            <Route path={level2.path}>
                              {level2.sub.map((level3, level3Idx) => (
                                <Route
                                  key={level3Idx}
                                  path={level3.path}
                                  element={level3.element}
                                />
                              ))}
                            </Route>
                          </Route>
                        );
                      }

                      return null;
                    })}
                  </Fragment>
                );
              }

              return null;
            })}
            {/* Nav Menu */}
            {menuNav.map((level1, level1Idx) => {
              if (level1.element && level1.sub.length === 0) {
                return (
                  <Route
                    key={level1Idx}
                    path={level1.path}
                    element={level1.element}
                  />
                );
              }

              if (!level1.element && level1.sub.length > 0) {
                return (
                  <Fragment key={level1Idx}>
                    {level1.sub.map((level2, level2Idx) => {
                      // Level 2
                      if (level2.element && level2.sub.length === 0) {
                        return (
                          <Route key={level2Idx} path={level1.path}>
                            <Route
                              path={level2.path}
                              element={level2.element}
                            />
                          </Route>
                        );
                      }

                      return null;
                    })}
                  </Fragment>
                );
              }

              return null;
            })}
          </Route>
        </Route>
        <Route path="*" element={<Beranda />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
